import React from "react";
import PropTypes from "prop-types";
import File from "rialto-icons/File";

import Button from "components/Button";
import Dropzone from "components/Dropzone";
import Translate from "utils/translate";

import styles from "forms/forms.css";

const { t } = new Translate("ProposalForm");

const FileField = ({ accept, field: { name, value }, form, isButton, isPicture, label }) => {
  if (isButton) {
    return (
      <div className={styles.field}>
        <Button
          hasFile={!!value}
          icon={<File />}
          label={value ? value.name : t("upload")}
          onFilePicked={(v) => form.setFieldValue(name, v)}
          isFilePicker
        />
      </div>
    );
  }

  return (
    <div className={styles.field}>
      {label && <label>{label}</label>}
      <Dropzone
        accept={accept}
        isPicture={isPicture}
        onChange={(v) => form.setFieldValue(name, v)}
      />
    </div>
  );
};

FileField.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string),
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.object,
  }).isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  isButton: PropTypes.bool,
  isPicture: PropTypes.bool,
  label: PropTypes.string,
};

export default FileField;
